var React = require('react');

function TimeInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#f5f5f5"},[React.createElement("rect",{"height":"14","rx":"7","width":"14","x":"2.5","y":"2.5","key":0}),React.createElement("g",{"fill":"#252525","strokeWidth":".5","key":1},[React.createElement("path",{"d":"m9.25 9.25h3.5v.5h-3.5z","key":0}),React.createElement("path",{"d":"m9.25 9.75h4.5v.5h-4.5z","transform":"matrix(0 -1 1 0 -.5 19)","key":1})])]));
}

TimeInline.defaultProps = {"fill":"none","height":"18","viewBox":"0 0 18 18","width":"18"};

module.exports = TimeInline;

TimeInline.default = TimeInline;
